import { dayjs } from '@tunasong/models'
import type { MaterialColor } from '@tunasong/plugin-lib'
import cn from 'classnames'
import React from 'react'
import type { FC, Ref } from 'react'
import styles from './chat-item.module.css'

export interface ChatItemProps {
  name: string
  timestamp: string
  UserIcon: FC

  color?: MaterialColor

  children: React.ReactNode
  actions?: React.ReactNode

  highlight?: boolean
  type: 'message' | 'response' | 'assistant'

  ref: Ref<HTMLDivElement>
}

/**
 * One comment: avatar, name and time, body, then its actions (chat makeover M3, #2718). One column with no bubbles,
 * whoever wrote it, in the agent thread's typography. `type` still marks an assistant comment, for its accent.
 */
export const ChatItem: FC<ChatItemProps> = props => {
  const { name, actions, UserIcon, type, highlight, timestamp, children, ref } = props

  return (
    <div
      ref={ref}
      className={cn(styles.item, styles[`item--${type}`], highlight && styles['item--highlight'])}
      data-chat-item-type={type}
    >
      <div className={styles.avatar}>
        <UserIcon />
      </div>
      <div className={styles.main}>
        <div className={styles.meta}>
          <span className={styles.name}>{name}</span>
          <time className={styles.time} dateTime={timestamp} title={dayjs(timestamp).format('LLL')}>
            {dayjs(timestamp).fromNow()}
          </time>
        </div>
        <div className={styles.body}>{children}</div>
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  )
}

export default ChatItem
